import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useBirthChartsDataContext } from './hooks/useBirthChartsDataContext';

export const Labor = () => {
    const { chartData } = useBirthChartsDataContext();


    return (
        <SimpleBars
            title={'Trabalho de Parto'}
            horizontal={false}
            subtitles={chartData?.labor?.map((item) => item.description)}
            values={chartData?.labor?.map((item) => item.total  ||  0)}
        />
    );
};
